import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import { PrimaryButton, SecondaryButton, GhostButton, TextButton, OutlineButton, Loader, IconWrap, LeftIconWrap, RightIconWrap } from './Button.styles';

var mapSize = function mapSize(size) {
  return "size".concat(capitalize(size));
};

var mapColor = function mapColor(color) {
  return "color".concat(capitalize(color));
};

var selectVariant = function selectVariant(variant) {
  switch (variant) {
    case 'primary':
      {
        return PrimaryButton;
      }

    case 'secondary':
      {
        return SecondaryButton;
      }

    case 'ghost':
      {
        return GhostButton;
      }

    case 'text':
      {
        return TextButton;
      }

    case 'outline':
      {
        return OutlineButton;
      }

    default:
      return PrimaryButton;
  }
};

var Button = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      _d = _a.color,
      color = _d === void 0 ? 'primary' : _d,
      onClick = _a.onClick,
      href = _a.href,
      disabled = _a.disabled,
      loading = _a.loading,
      fullWidth = _a.fullWidth,
      className = _a.className,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon,
      icon = _a.icon,
      props = __rest(_a, ["children", "variant", "size", "color", "onClick", "href", "disabled", "loading", "fullWidth", "className", "leftIcon", "rightIcon", "icon"]);

  var ButtonStyled = selectVariant(variant);
  var combinedClassName = classnames(className, mapSize(size), mapColor(color), {
    disabled: disabled,
    loading: loading,
    fullWidth: fullWidth,
    withIcon: Boolean(icon)
  });
  return _jsxs(ButtonStyled, __assign({
    type: "button",
    onClick: loading ? undefined : onClick,
    as: href ? 'a' : 'button',
    href: loading ? undefined : href,
    disabled: disabled || loading,
    className: combinedClassName,
    ref: ref
  }, props, {
    children: [leftIcon && !icon && _jsx(LeftIconWrap, {
      children: leftIcon
    }), icon ? _jsx(IconWrap, {
      children: icon
    }) : children, rightIcon && !icon && _jsx(RightIconWrap, {
      children: rightIcon
    }), loading && _jsx(Loader, {})]
  }));
});
export default React.memo(Button);